import React, { useEffect, useState } from "react";
import "./BlogMain.css";
import { ReactComponent as ArrowRight } from "../../assets/blog/arrow-right.svg";
import { Link } from "react-router-dom";
import API_BASE_URL from "../../config"; // Import your API base URL
import { AnimatedButton } from "../common/AnimatedButton";
const BlogMain = () => {
  const [blogPosts, setBlogPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(()=>{
    fetch(`${API_BASE_URL}/blogs/`)
      .then((res) => res.json())
      .then((data) => {
        console.log("Fetched blogs:", data);
        setBlogPosts(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Failed to fetch blogs:", err);
        setLoading(false);
      });
      },350)
  }, []);

  // if (loading) return <p>Loading blogs...</p>;
  // if (!blogPosts.length) return <p>No blogs found.</p>;

  return (
    <>
      {loading ? (
        <div
          className="custom-loader"
          style={{height:'65vh',width:'100vw',position:'relative',zIndex:'1'}}
        >
          <div className="dots-loader">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      ) : (
        <section className="blog-main">
          <h2 className="blog-title">
            Fresh updates and behind-the-scenes from <span>Webunny</span>
          </h2>

          <div className="blog-list">
            {blogPosts?.map((post, index) => {
              return (
                <div
                  className={`blog-card ${index % 2 === 1 ? "reverse" : ""}`}
                  key={post.id}
                >
                  <div className="blog-image">
                    {post.image_url ? (
                      <img src={post.image_url} alt={post.title} onLoad={(e) => e.currentTarget.classList.add("show")} className="imag"/>
                    ) : (
                      <div className="blog-placeholder">No Image</div>
                    )}
                  </div>

                  <div className="blog-content">
                    <p className="blog-date">
                      {new Date(post.created_at).toLocaleDateString()}
                    </p>
                    <h3 className="blog-heading">{post.title}</h3>
                    <p className="blog-description">{post.description}</p>

                    {/* <Link
                      to={`/blog/${post.slug}`}
                      className="blog-button-rounded"
                    >
                      <span className="button-text">Read More</span>
                      <span className="button-icon">
                        <ArrowRight className="arrow-icon" />
                      </span>
                    </Link> */}
                    <AnimatedButton link={`/blog/${post.slug}`} label="Read More" />
                  </div>
                </div>
              );
            })}
          </div>
        </section>
      )}
    </>
  );
};

export default BlogMain;
